/**
 * Template lists withhold the pages of paid and premium templates from callers
 * who are not entitled to them (the card keeps its picture). When one is chosen,
 * fetch it through the detail endpoint, which applies the entitlement rule.
 *
 * Resolves to { template } when the pages are available, otherwise
 * { denied: 'purchase', templateId } | { denied: 'pro' } | { denied: 'unavailable' }.
 */
export async function resolveTemplateContent(template, { apiUrl, token }) {
  let json = template?.template_json;
  if (typeof json === 'string') {
    try { json = JSON.parse(json); } catch { json = null; }
  }
  if (Array.isArray(json?.pages) && json.pages.length > 0) return { template };

  try {
    const res = await fetch(
      `${apiUrl}/api/public/templates/${template.id}`,
      token ? { headers: { Authorization: `Bearer ${token}` } } : {},
    );
    if (res.ok) return { template: await res.json() };
    if (res.status === 403) {
      let detail = null;
      try { detail = (await res.json())?.detail ?? null; } catch { /* not JSON */ }
      if (detail && typeof detail === 'object' && detail.code === 'purchase_required') {
        return { denied: 'purchase', templateId: detail.template_id || template.id };
      }
      return { denied: 'pro' };
    }
    return { denied: 'unavailable' };
  } catch {
    return { denied: 'unavailable' };
  }
}
